/** Shared structural styles for operator forms.
 *
 * Cards are the page-level container. Groups/fieldsets are inset concepts
 * inside a card. Alerts and destructive regions intentionally do not use
 * these classes because color there communicates state rather than hierarchy.
 */
export const OPERATOR_FORM_CARD = 'rounded-token-card bg-surface-card p-6'
export const OPERATOR_FORM_STACK = 'space-y-4'
export const OPERATOR_FIELD_GROUP =
  'space-y-3 rounded-token-card border border-border-default bg-surface-app p-4 ' +
  '[&_input:not([type=checkbox])]:bg-surface-card [&_textarea]:bg-surface-card ' +
  '[&_[role=combobox]]:bg-surface-card'
export const OPERATOR_FIELDSET_LEGEND = 'px-1 text-body font-medium'
